"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDictateState;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

// TODO: [P3] We should update this code to use core/src/selectors/dictateState.js
function useDictateState() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var dictateState = _ref.dictateState;
    return dictateState;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VEaWN0YXRlU3RhdGUiLCJ1c2VTZWxlY3RvciIsImRpY3RhdGVTdGF0ZSJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZURpY3RhdGVTdGF0ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5cbi8vIFRPRE86IFtQM10gV2Ugc2hvdWxkIHVwZGF0ZSB0aGlzIGNvZGUgdG8gdXNlIGNvcmUvc3JjL3NlbGVjdG9ycy9kaWN0YXRlU3RhdGUuanNcbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZURpY3RhdGVTdGF0ZSgpOiBbbnVtYmVyXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgZGljdGF0ZVN0YXRlIH0pID0+IGRpY3RhdGVTdGF0ZSldO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7QUFDZSxTQUFTQSxlQUFULEdBQXFDO0VBQ2xELE9BQU8sQ0FBQyxJQUFBQyxnQ0FBQSxFQUFZO0lBQUEsSUFBR0MsWUFBSCxRQUFHQSxZQUFIO0lBQUEsT0FBc0JBLFlBQXRCO0VBQUEsQ0FBWixDQUFELENBQVA7QUFDRCJ9